import {hpcAttrs} from '@github-ui/hpc'
import {use} from 'react'

import {Hero, Grid, Text} from '@primer/react-brand/esm'

import {PlanTypeSegmentedControl} from '../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'

import {PlanTypeContext} from '../_context/PlanTypeContext'

import {PricingPlans} from '../_components/PricingPlans/PricingPlans'
import IdeList from '../_components/IdeList/IdeList'

import type {HeroSectionContent} from './HeroSection/content'

type Props = {
  content: HeroSectionContent
}

export function HeroSection({content}: Props) {
  const {hero, ideList, planItems, planTypes, pricingOptions} = content
  const {planType, setPlanType} = use(PlanTypeContext)

  return (
    <Grid as="section" className="position-relative">
      <Grid.Column span={12}>
        {hero ? (
          <Hero align="center" className="tmp-pb-4">
            <Hero.Heading size="2" {...hpcAttrs()}>
              {hero.fields.heading}
            </Hero.Heading>
          </Hero>
        ) : null}

        {planTypes ? (
          <div className="d-flex flex-justify-center px-2 tmp-mb-7">
            <h2 className="visually-hidden" id="pricing-plans">
              {planTypes.fields.heading || 'Pricing plans'}
            </h2>

            <PlanTypeSegmentedControl
              value={planType}
              onChange={setPlanType}
              items={planItems}
              heading={planTypes.fields.heading || 'Pricing plans'}
            />
          </div>
        ) : null}

        {pricingOptions ? <PricingPlans contentfulContent={pricingOptions} /> : null}

        <div className="tmp-mb-5">
          {ideList ? (
            <Text as="p" size="200" variant="muted" weight="normal" align="center" className="tmp-mb-5">
              {ideList.fields.heading}
            </Text>
          ) : null}

          <IdeList type="small" location="pricing-cards" />
        </div>
      </Grid.Column>
    </Grid>
  )
}
